import { getAdditionalCategoryFailureAction, getAdditionalCategorySuccessAction } from '../actions';
import { BrandedNotificationGetService } from '../services';
import { getLocalLanguageCode } from '@mitchell/react.component.ux';
import { call, put } from 'redux-saga/effects';
export function* fetchBrandedNotificationAdditonalCategorySaga(action, 
/*istanbul ignore next*/
branbedNotificationService = new BrandedNotificationGetService()) {
    const { companyCode } = action.payload;
    let { languageCode } = action.payload;
    if (!languageCode) {
        languageCode = getLocalLanguageCode();
    }
    const id = `${companyCode}:${languageCode}`;
    try {
        const category = yield call({ context: branbedNotificationService, fn: branbedNotificationService.getCategories }, companyCode, languageCode);
        const payload = {
            id: id,
            companyCode: companyCode,
            languageCode: languageCode,
            response: category
        };
        yield put(getAdditionalCategorySuccessAction(payload));
    }
    catch (error) {
        // if API call fails then empty category will be saved
        const payload = {
            id: id,
            companyCode: companyCode,
            languageCode: languageCode,
            response: []
        };
        yield put(getAdditionalCategoryFailureAction(payload));
    }
}
//# sourceMappingURL=fetchBrandedNotificationAdditonalCategorySaga.js.map